import {PieChart} from 'react-minimal-pie-chart';
import './WorkIndicator.scss';

const WorkIndicator = function(props) {
	let loader = '';
	switch (props.loaderType) {
		case 'progress':
			let loaderLabel = `${props.progress}%`;
			loader = (
				<div className="loader-chart">
				<PieChart
				data={[
					{title: 'Working', value: props.progress, color: '#039669'},
				]}
				totalValue={100}
				startAngle={270}
				lineWidth="16"
				rounded={true}
				animate={true}
				background="#dadada"
			/>
			<p className="loader-progress-value">{loaderLabel}</p>
			</div>
			)
			break;
		case 'none':
			loader = '';
			break;
		default:
			loader = (<div className="loader"></div>);
	}

	let loadingData = '';

	if (props.loadingData) {
		let dataItems = [];
		if (props.loadingData.focusKeyword) {
			dataItems.push((<li key={`data-item-${dataItems.legth}`}><b>{window?.t?.LBL_FOCUS_KEYWORD}:</b> {props.loadingData.focusKeyword}</li>));
		}
		if (props.loadingData.language) {
			dataItems.push((<li key={`data-item-${dataItems.legth}`}><b>{window?.t?.LANGUAGE}:</b> {props.loadingData.language}</li>));
		}
		loadingData = (<ul className="loading-data">{dataItems}</ul>);
	}

	return (
		<div className="overlay">
			<div className="pop-up working">
				<h2 className="pop-up-title">{props.title}</h2>
				{props.loadingData ? loadingData : ''}
				<p className="pop-up-title-info">{props.titleInfo}</p>
				<div className="loader-section">{loader}</div>
				<p className="pop-up-info">{props.info}</p>
				<p className="pop-up-details">{props.details}</p>
			</div>
		</div>
	);
}

export default WorkIndicator;